import script from "./CAtmosphereBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./CAtmosphereBase.vue?vue&type=script&setup=true&lang=ts"

import "./CAtmosphereBase.vue?vue&type=style&index=0&id=1f23b88d&scoped=true&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f23b88d"]])

export default __exports__